<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon info">
      <i class="fa-solid fa-user-gear"></i>
    </div>
    <div>
      <h2 class="dialog-title">My Profile</h2>
      <p class="dialog-subtitle">Account and access settings</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onClose()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <!-- Avatar Section -->
  <div class="profile-avatar-section">
    <div class="profile-avatar-large">
        <span class="avatar-content">{{ state.getUserInitials() }}</span>
    </div>
  </div>

  <!-- Profile Fields -->
  <div class="profile-fields">
    <div class="profile-field">
      <span class="profile-field-label">Name</span>
      <span class="profile-field-value">{{ state.getUserName() }}</span>
    </div>
    <div class="profile-field">
      <span class="profile-field-label">Email</span>
      <span class="profile-field-value">{{ userAttributes.email }}</span>
    </div>
    <div class="profile-field">
      <span class="profile-field-label">Role</span>
      <span class="profile-field-value">{{ decodeUserType() }}</span>
    </div>
    @if( userAttributes.office != null || userAttributes.agency != null ) {
        <div class="profile-field">
            <span class="profile-field-label">Office / Agency / Customer</span>
            <span class="profile-field-value">{{ decodeOfficeAgency() }}</span>
        </div>
    }
    <div class="profile-field">
      <span class="profile-field-label">Last Access</span>
      <span class="profile-field-value">{{ userAttributes.lastLogin | date }}</span>
    </div>
  </div>

  <!-- Module Access -->
  <div class="profile-modules-section">
    <div class="profile-field-label" style="margin-bottom: 8px;">Module Access</div>
    <div class="profile-modules">
      @for (module of modules; track module.name) {
        <span
          class="profile-module-pill"
          [class.disabled]="!module.enabled">
          {{ module.name }}
        </span>
      }
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onChangePassword()">Change Password</button>
</mat-dialog-actions>
